(function () {
  'use strict';

  /* sticky/transparent header on homepage */
  var header = document.querySelector('.site-header');
  var transparent = document.body.classList.contains('allow-transparent-header');
  if (header && transparent) {
    var onScroll = function () {
      if (window.scrollY > 40) header.classList.add('is-stuck');
      else header.classList.remove('is-stuck');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* mobile nav toggle */
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.getElementById('SiteNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* scroll reveal */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = document.querySelectorAll('.reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* product thumbnails swap main image */
  var gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    var main = gallery.querySelector('[data-main-image]');
    gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) { main.src = t.getAttribute('data-full'); main.srcset = ''; }
      });
    });
  }
})();

/* keep transparent homepage header sitting just below the announcement bar */
(function(){
  function setAnnH(){
    var a = document.querySelector('.announcement');
    document.documentElement.style.setProperty('--ann-h', (a ? a.offsetHeight : 0) + 'px');
  }
  setAnnH();
  window.addEventListener('resize', setAnnH);
  window.addEventListener('load', setAnnH);
})();

/* =====================================================
   CART DRAWER + REC POPUP
   ===================================================== */
(function () {
  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  var itemsEl      = document.getElementById('CartDrawerItems');
  var recsEl       = document.getElementById('CartDrawerRecs');
  var totalEl      = document.getElementById('CartDrawerTotal');
  var barEl        = document.getElementById('CartProgressBar');
  var textEl       = document.getElementById('CartProgressText');
  var threshold    = parseInt(drawer.getAttribute('data-threshold'), 10) || 0;
  var belowTpl     = drawer.getAttribute('data-below') || 'Spend {remaining} more to unlock 15% off!';
  var reachedTpl   = drawer.getAttribute('data-reached') || "You've unlocked the discount!";
  var lastCacheKey = '';

  /* Rec popup elements */
  var recPopup      = document.getElementById('RecPopup');
  var recPopupTitle = document.getElementById('RecPopupTitle');
  var recPopupImg   = document.getElementById('RecPopupImg');
  var recPopupSel   = document.getElementById('RecPopupSelectors');
  var recPopupAdd   = document.getElementById('RecPopupAdd');
  var popupVariants = [];
  var popupSelected = {};

  var TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">' +
    '<polyline points="3 6 5 6 21 6"/>' +
    '<path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>' +
    '<path d="M10 11v6M14 11v6"/>' +
    '<path d="M9 6V4h6v2"/>' +
    '</svg>';

  function fmtMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function resizeImg(url, w) {
    if (!url) return '';
    if (url.slice(0, 2) === '//') url = 'https:' + url;
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    return url + sep + 'width=' + w;
  }

  function getProductImg(p) {
    var fi = p.featured_image;
    if (fi) {
      if (typeof fi === 'string') return fi;
      if (fi.url) return fi.url;
      if (fi.src) return fi.src;
    }
    if (p.images && p.images.length) {
      var img = p.images[0];
      if (typeof img === 'string') return img;
      if (img.src) return img.src;
      if (img.url) return img.url;
    }
    return '';
  }

  /* ---------- DRAWER OPEN / CLOSE ---------- */
  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  }

  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  function updateBadge(count) {
    var b = document.querySelector('[data-cart-count]');
    if (!b) return;
    b.textContent = count;
    b.style.display = count > 0 ? '' : 'none';
  }

  /* ---------- REC POPUP ---------- */
  function openRecPopup(handle) {
    if (!recPopup) return;
    fetch('/products/' + handle + '.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var p = data.product;
        popupVariants = p.variants;
        popupSelected = {};

        if (recPopupTitle) recPopupTitle.textContent = p.title;

        if (recPopupImg) {
          var src = getProductImg(p);
          if (src) {
            recPopupImg.src = resizeImg(src, 200);
            recPopupImg.alt = p.title;
            recPopupImg.style.display = '';
          } else {
            recPopupImg.style.display = 'none';
          }
        }

        /* Build option pills — skip default single-option products */
        var defaultOnly = p.options.length === 1 && p.options[0].name === 'Title';
        if (recPopupSel) {
          if (defaultOnly) {
            recPopupSel.innerHTML = '';
            popupSelected[0] = 'Default Title';
          } else {
            recPopupSel.innerHTML = p.options.map(function (opt, i) {
              return '<div class="rec-popup__opt-group">' +
                '<label>' + esc(opt.name) + '</label>' +
                '<div class="rec-popup__opts">' +
                  opt.values.map(function (val) {
                    return '<button type="button" class="rec-popup__opt"' +
                      ' data-opt-i="' + i + '"' +
                      ' data-opt-v="' + esc(val) + '">' +
                      esc(val) +
                    '</button>';
                  }).join('') +
                '</div></div>';
            }).join('');
            /* Pre-select first available variant's options */
            p.options.forEach(function (opt, i) {
              popupSelected[i] = p.variants[0]['option' + (i + 1)];
            });
          }
        }

        updatePopupUI();
        recPopup.setAttribute('aria-hidden', 'false');
      });
  }

  function closeRecPopup() {
    if (recPopup) recPopup.setAttribute('aria-hidden', 'true');
  }

  function updatePopupUI() {
    if (!recPopupSel || !recPopupAdd) return;

    recPopupSel.querySelectorAll('.rec-popup__opt').forEach(function (btn) {
      var i   = parseInt(btn.getAttribute('data-opt-i'), 10);
      var val = btn.getAttribute('data-opt-v');
      btn.classList.toggle('is-selected', popupSelected[i] === val);
      /* Disable only if every variant with this value is explicitly marked unavailable */
      var avail = popupVariants.some(function (v) {
        return v['option' + (i + 1)] === val && v.available !== false;
      });
      btn.disabled = !avail;
    });

    /* Find the variant that matches every currently selected option */
    var matched = popupVariants.find(function (v) {
      return Object.keys(popupSelected).every(function (k) {
        return v['option' + (parseInt(k, 10) + 1)] === popupSelected[k];
      });
    });

    var inStock = matched && matched.available !== false;
    recPopupAdd.disabled = !inStock;
    recPopupAdd.textContent = matched ? (inStock ? 'Add to Cart' : 'Sold out') : 'Add to Cart';
    recPopupAdd.setAttribute('data-vid', matched ? matched.id : '');
  }

  /* Option pill clicks (delegation on selector container) */
  if (recPopupSel) {
    recPopupSel.addEventListener('click', function (e) {
      var btn = e.target.closest('.rec-popup__opt');
      if (!btn || btn.disabled) return;
      popupSelected[parseInt(btn.getAttribute('data-opt-i'), 10)] = btn.getAttribute('data-opt-v');
      updatePopupUI();
    });
  }

  /* Add to cart from popup */
  if (recPopupAdd) {
    recPopupAdd.addEventListener('click', function () {
      var vid = recPopupAdd.getAttribute('data-vid');
      if (!vid) return;
      var orig = recPopupAdd.textContent;
      recPopupAdd.disabled = true;
      recPopupAdd.textContent = 'Adding…';
      var fd = new FormData();
      fd.append('id', vid);
      fd.append('quantity', '1');
      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function (r) {
          if (!r.ok) throw new Error();
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          closeRecPopup();
          lastCacheKey = '';
          renderCart(cart);
        })
        .catch(function () {
          recPopupAdd.disabled = false;
          recPopupAdd.textContent = orig;
        });
    });
  }

  /* Close popup triggers */
  if (recPopup) {
    Array.prototype.forEach.call(recPopup.querySelectorAll('[data-rec-close]'), function (el) {
      el.addEventListener('click', closeRecPopup);
    });
  }

  /* ---------- RECOMMENDATIONS ---------- */
  function renderRecProducts(products) {
    if (!recsEl || !products.length) { if (recsEl) recsEl.innerHTML = ''; return; }
    recsEl.innerHTML = '<p class="cart-drawer__recs-title">You may also like</p>' +
      products.map(function (p) {
        var imgUrl = resizeImg(p.imgUrl || '', 120);
        var imgHtml = imgUrl
          ? '<img src="' + esc(imgUrl) + '" alt="' + esc(p.title) + '" width="60" height="80" loading="lazy">'
          : '<div style="width:60px;height:80px;background:var(--mat);border-radius:var(--radius);flex-shrink:0;"></div>';
        var priceLabel = (p.price_varies ? 'From ' : '') + fmtMoney(p.price);
        var addBtn = p.handle
          ? '<button class="cart-rec-item__add" data-rec-handle="' + esc(p.handle) + '" aria-label="Add to cart">+</button>'
          : '';
        return (
          '<div class="cart-rec-item">' +
            imgHtml +
            '<div class="cart-rec-item__info">' +
              '<div class="cart-rec-item__name">' + esc(p.title) + '</div>' +
              '<div class="cart-rec-item__price">' + esc(priceLabel) + '</div>' +
            '</div>' +
            '<div class="cart-rec-item__btns">' +
              '<a href="' + esc(p.url) + '" class="cart-rec-item__btn">View</a>' +
              addBtn +
            '</div>' +
          '</div>'
        );
      }).join('');
  }

  /* "+" button on rec items opens popup (delegation on recs container) */
  if (recsEl) {
    recsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rec-handle]');
      if (btn) openRecPopup(btn.getAttribute('data-rec-handle'));
    });
  }

  function fetchRecs(cart) {
    if (!recsEl) return;

    var strategy   = drawer.getAttribute('data-rec-strategy') || 'automatic';
    var recCount   = parseInt(drawer.getAttribute('data-rec-count'), 10) || 3;
    var collection = drawer.getAttribute('data-rec-collection') || '';
    var cacheKey   = strategy === 'manual'     ? 'manual'
                   : strategy === 'collection' ? ('col:' + collection + ':' + recCount)
                   : (cart.items && cart.items[0] ? (cart.items[0].product_id + ':' + recCount) : '');

    if (!cacheKey) { recsEl.innerHTML = ''; return; }
    if (!cart.items || !cart.items.length) { recsEl.innerHTML = ''; lastCacheKey = ''; return; }
    if (cacheKey === lastCacheKey) return;
    lastCacheKey = cacheKey;

    /* Manual hand-picked */
    if (strategy === 'manual') {
      var manualEl = document.getElementById('CartManualRecs');
      if (!manualEl) { recsEl.innerHTML = ''; return; }
      var manualData;
      try { manualData = JSON.parse(manualEl.textContent); } catch (e) { recsEl.innerHTML = ''; return; }
      renderRecProducts(manualData.slice(0, recCount).map(function (p) {
        return { title: p.title, url: p.url, handle: p.handle || '', price: p.price, price_varies: p.price_varies, imgUrl: p.image || '' };
      }));
      return;
    }

    /* From a specific collection */
    if (strategy === 'collection') {
      if (!collection) { recsEl.innerHTML = ''; return; }
      fetch('/collections/' + encodeURIComponent(collection) + '/products.json?limit=' + recCount)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          renderRecProducts((data.products || []).slice(0, recCount).map(function (p) {
            return { title: p.title, url: p.url || ('/products/' + p.handle), handle: p.handle, price: p.price, price_varies: p.price_varies || false, imgUrl: getProductImg(p) };
          }));
        })
        .catch(function () { recsEl.innerHTML = ''; });
      return;
    }

    /* Automatic AI recommendations */
    var pid = cart.items[0].product_id;
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=' + recCount + '&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        renderRecProducts((data.products || []).slice(0, recCount).map(function (p) {
          return { title: p.title, url: p.url, handle: p.handle, price: p.price, price_varies: p.price_varies || false, imgUrl: getProductImg(p) };
        }));
      })
      .catch(function () { recsEl.innerHTML = ''; });
  }

  /* ---------- CART RENDER ---------- */
  function renderCart(cart) {
    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (item) {
        var imgUrl = item.featured_image && item.featured_image.url
          ? resizeImg(item.featured_image.url, 144) : '';
        var imgHtml = imgUrl
          ? '<img src="' + esc(imgUrl) + '" alt="' + esc(item.product_title) + '" width="72" height="90" loading="lazy">'
          : '<div style="width:72px;height:90px;background:var(--mat);border-radius:var(--radius);flex-shrink:0;"></div>';
        return (
          '<div class="cart-drawer-item">' +
            imgHtml +
            '<div class="cart-drawer-item__info">' +
              '<div class="cart-drawer-item__name">' + esc(item.product_title) + '</div>' +
              (item.variant_title ? '<div class="cart-drawer-item__variant">' + esc(item.variant_title) + '</div>' : '') +
              '<div class="cart-drawer-item__qty">Qty ' + item.quantity + '</div>' +
            '</div>' +
            '<div class="cart-drawer-item__actions">' +
              '<span class="cart-drawer-item__price">' + fmtMoney(item.final_line_price) + '</span>' +
              '<button class="cart-item__remove" data-remove="' + esc(item.key) + '" aria-label="Remove item">' +
                TRASH +
              '</button>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }

    if (totalEl) totalEl.textContent = fmtMoney(cart.total_price);

    if (barEl && textEl && threshold) {
      var pct = Math.min(100, (cart.total_price / threshold) * 100);
      var remaining = Math.max(0, threshold - cart.total_price);
      barEl.style.width = pct + '%';
      textEl.textContent = remaining > 0
        ? belowTpl.replace('{remaining}', fmtMoney(remaining))
        : reachedTpl;
    }

    updateBadge(cart.item_count);
    fetchRecs(cart);
  }

  function removeItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); });
  }

  function fetchAndOpen() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); openDrawer(); });
  }

  /* Trash button — event delegation */
  if (itemsEl) {
    itemsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-remove]');
      if (btn) removeItem(btn.getAttribute('data-remove'));
    });
  }

  /* Drawer close triggers */
  Array.prototype.forEach.call(drawer.querySelectorAll('[data-drawer-close]'), function (el) {
    el.addEventListener('click', closeDrawer);
  });

  /* ESC: close popup first if open, then drawer */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (recPopup && recPopup.getAttribute('aria-hidden') === 'false') closeRecPopup();
    else closeDrawer();
  });

  /* Cart icon → open drawer */
  var cartLink = document.querySelector('.header-actions a[href*="cart"]');
  if (cartLink) {
    cartLink.addEventListener('click', function (e) {
      e.preventDefault();
      fetchAndOpen();
    });
  }

  /* Intercept Add to Cart form */
  var form = document.getElementById('ProductForm');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add]');
      var origText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) throw new Error();
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCart(cart);
          openDrawer();
          if (btn) { btn.disabled = false; btn.textContent = origText; }
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = origText; }
          form.submit();
        });
    });
  }

  window.CartDrawer = { open: fetchAndOpen, close: closeDrawer };
})();
